import script from "./ml-image.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-image.vue?vue&type=script&setup=true&lang=js"

import "./ml-image.vue?vue&type=style&index=0&id=0933c496&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\tatu\\tatu_25_5_24\\3.1源代码_25_4_3\\前端-源代码\\smart-battery-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0933c496"]])

export default __exports__